/* global __CLIENT__*/
import classNames from 'classnames';
import { Map } from 'immutable';
import capitalize from 'lodash/capitalize';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { elementTypesSelector } from '../../../reducers/elementTypes';
import { currentProjectIdSelector } from '../../../reducers/projects';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

// import '../../styles/ProjectUsers.css';

const ElementsByTypeSelector = immutableCreatorSelector(
  [elementTypesSelector, currentProjectIdSelector],
  (elementTypes, currentProjectId) => {
    return {
      elementTypes,
      currentProjectId,
    };
  },
);

@connect(ElementsByTypeSelector)
export default class ProjectSettingsNav extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    elementTypes: PropTypes.instanceOf(Map),
    location: PropTypes.object,
    navType: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const projectId = props.currentProjectId;

    this.state = {
      navListItems: {
        settings: [
          {
            name: 'Project',
            hyphen: 'project',
            url: `/project/${projectId}/settings/project`,
          },
          {
            name: 'Baselines',
            hyphen: 'baselines',
            url: `/project/${projectId}/settings/baselines`,
          },
          {
            name: 'Element Types',
            hyphen: 'element-types',
            url: `/project/${projectId}/settings/element-types`,
          },
          {
            name: 'Relationship Types',
            hyphen: 'relationship-types',
            url: `/project/${projectId}/settings/relationship-types`,
          },
          {
            name: 'Daily Activity Report',
            hyphen: 'daily',
            url: `/project/${projectId}/settings/reports/daily`,
          },
          {
            name: 'Company',
            hyphen: 'company',
            override: 'Companies',
          },
          {
            name: 'Export',
            hyphen: 'export',
            url: `/project/${projectId}/settings/export`,
          },
          {
            name: 'Users',
            hyphen: 'users',
            url: `/project/${projectId}/settings/users`,
          },
        ],
      },
    };
  }

  navListItem = (
    url,
    label,
    urlPath,
    elementTypes,
    elementTypeCheck,
    labelOverride,
  ) => {
    const {
      location: { pathname },
    } = this.props;

    const path = pathname.split('/');

    const activeCheck = elementTypeCheck
      ? path.pop() === urlPath
      : elementTypes.findKey(eleType => {
          return capitalize(eleType.get('type')) === label;
        }) === path[path.length - 2];

    const navItemClass = classNames({
      'nav-link': true,
      active: activeCheck,
    });

    return (
      <li key={urlPath} className="settings-nav-item">
        <Link className={navItemClass} to={url}>
          {labelOverride || label}
        </Link>
      </li>
    );
  };

  buildElementTypeUrl = (navItem, currentProjectId) => {
    const { elementTypes } = this.props;

    const elementTypeId = elementTypes.findKey(
      eleType => eleType.get('type') === navItem,
    );

    return `/project/${currentProjectId}/settings/element-type/${elementTypeId}/elements`;
  };

  renderNavList = () => {
    const { navListItems } = this.state;
    const { currentProjectId, elementTypes, navType } = this.props;

    return navListItems[navType].map(navItem => {
      const url =
        navItem.url || this.buildElementTypeUrl(navItem.name, currentProjectId);
      return this.navListItem(
        url,
        navItem.name,
        navItem.hyphen,
        elementTypes,
        navItem.url,
        navItem.override,
      );
    });
  };

  render() {
    return (
      <div
        className="col-md-2"
        style={{ borderRight: '1px solid #ddd', paddingTop: 10 }}
      >
        <ul className="nav flex-column nav-pills nav-justified">
          {this.renderNavList()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbars/LeftNav/LeftNav.js